import { t } from '@lingui/macro';
import { Alert } from '@pocketlaw/tetris';
export function ErrorMessage() {
    return (<Alert appearance="danger" message={t({ message: 'An error occurred.', comment: 'Error alert message' })}/>);
}
